import { VButton, cn } from '@vrzl/ui';
import { type ReactNode, useId, useRef, useState } from 'react';

import { toggleButtonClass } from '../constants';
import { useIsClamped } from '../hooks/useIsClamped';

/**
 * Kapt inline inhoud af op 3 regels met "Meer lezen". Kinderen moeten inline zijn
 * (span), anders werkt line-clamp niet. Op papier staat altijd de volledige tekst.
 */
export function ClampedText({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const id = useId();
  const [expanded, setExpanded] = useState(false);
  // Alleen meten zolang ingeklapt; uitgeklapt blijft de knop staan, ook als de tekst inmiddels past.
  const clamped = useIsClamped(ref, !expanded);

  return (
    <div className="flex flex-col items-start gap-1">
      {/* self-stretch: de tekst houdt de volle breedte, alleen de knop staat links. */}
      <div
        id={id}
        ref={ref}
        className={cn('self-stretch', !expanded && 'line-clamp-3', 'print:line-clamp-none')}
      >
        {children}
      </div>
      {(clamped || expanded) && (
        <VButton
          type="button"
          variant="ghost"
          size="sm"
          aria-expanded={expanded}
          aria-controls={id}
          className={toggleButtonClass}
          onClick={() => setExpanded((v) => !v)}
        >
          {expanded ? 'Minder tonen' : 'Meer lezen'}
        </VButton>
      )}
    </div>
  );
}
